import { render, staticRenderFns } from "./example-layout.vue?vue&type=template&id=7a2a966e&"
import script from "./example-layout.vue?vue&type=script&lang=js&"
export * from "./example-layout.vue?vue&type=script&lang=js&"
import style0 from "./example-layout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports